import React, { useEffect, useState } from "react";
import "./privacypolicy.scss";
import Navbar from "../landing/header/Navbar";
import Footer from "../landing/footer/Footer";

const PrivacyPolicy = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsMobile(window.innerWidth <= 768);
  }, []);

  return (
    <div className="overflow-hidden">
      <Navbar />
      <section className="privacybanner">
        <img
          src={
            isMobile
              ? "/assets/banner/bannershadembl.png"
              : "/assets/banner/bannershade.png"
          }
          alt="img"
          className="bannershade"
        />
        <img
          src={isMobile ? "" : "/assets/banner/layer.png"}
          alt="img"
          className={isMobile ? "d-none" : "layerbg"}
        />
        <video
          className="main-banner-video"
          muted="muted"
          playsInline
          autoPlay
          loop
          width="100%"
        >
          <source src="/assets/banner/bannervideo.mp4.mov" type="video/mp4" />
        </video>
        <div className="custom-container">
          <div className="maincontent">
            <h2 className="head">Privacy Policy</h2>
            <p className="para">
              Learn how Traqstock collects, processes, stores and protects
              information.
            </p>
          </div>
        </div>
      </section>

      <section className="privacycontent">
        <div className="custom-container">
          <div className="policybox">
            <h1>Traqstock Privacy Policy</h1>
            <p className="dates">
              Effective Date: September 21, 2026 Last Updated: September 21,
              2026
            </p>
            <div className="intro">
              <p>
                Traqstock ("Traqstock," "we," "us," or "our") respects the
                privacy of the individuals, investors, companies, clients, and
                other users who interact with our websites, applications,
                dashboards, analytics systems, APIs, community features, and
                related services.
              </p>
              <p>
                This Privacy Policy explains how Traqstock collects, uses,
                processes, stores, protects, and discloses information in
                connection with our services (collectively, the "Services").
              </p>
              <p>
                Traqstock is a financial data intelligence and transparency
                platform. Our Services may include market-data aggregation and
                analysis, shareholder intelligence, historical analytics,
                behavioral indicators, company analytics, community features,
                API integrations, and blockchain-based data integrity and
                verification technologies.
              </p>
              <p>
                By accessing or using the Services, you acknowledge the
                practices described in this Privacy Policy.
              </p>
            </div>

            <div className="policysection">
              <h2>1. Scope Of This Policy</h2>
              <p>
                This Privacy Policy applies to personal information processed
                through Traqstock websites, applications, dashboards, APIs,
                community platforms, analytics products, blockchain-integrated
                systems, and related Services.
              </p>
              <p>
                Certain services provided to companies, issuers, organizations,
                or other business customers may also be governed by separate
                agreements, data-processing terms, licensing agreements, or
                other contractual arrangements. Those agreements may establish
                additional requirements regarding particular information.
              </p>
            </div>

            <div className="policysection">
              <h2>2. Information We May Collect</h2>
              <p>
                The information Traqstock collects depends upon how an
                individual or organization interacts with our Services.
              </p>
              <h3>Account Information</h3>
              <p>We may collect information such as:</p>
              <ul>
                <li>Name</li>
                <li>Username or display name</li>
                <li>Email address</li>
                <li>Telephone number</li>
                <li>Account identifiers</li>
                <li>Login and authentication information</li>
                <li>Account preferences</li>
                <li>Company or organizational affiliation</li>
                <li>Communications with Traqstock</li>
              </ul>
              <h3>Shareholder and Ownership Information</h3>
              <p>
                Where legally available, contractually authorized, and
                appropriate for the Services being provided, Traqstock may
                process shareholder and ownership-related information. Sources
                may include:
              </p>
              <ul>
                <li>NOBO or similar shareholder information</li>
                <li>Transfer-agent information</li>
                <li>Issuer-provided records</li>
                <li>Authorized broker, custodian, or intermediary information</li>
                <li>Ownership or position information</li>
                <li>Ownership changes</li>
                <li>Share quantities</li>
                <li>Historical ownership information</li>
                <li>Other authorized shareholder-related datasets</li>
              </ul>
              <p>
                Access to nonpublic shareholder information may be restricted
                according to applicable law, contractual requirements,
                authorization, and the role of the individual or organization
                requesting access.
              </p>
              <h3>Market and Trading Information</h3>
              <p>
                Traqstock may collect, receive, license, calculate, aggregate,
                or analyze market-related information. This information may
                include:
              </p>
              <ul>
                <li>Quotes</li>
                <li>Trades</li>
                <li>Price information</li>
                <li>Volume information</li>
                <li>Time-and-sales information</li>
                <li>Level II or order-book information</li>
                <li>Market-participant identifiers</li>
                <li>Historical trading information</li>
                <li>Short-volume information</li>
                <li>Settlement-related information</li>
                <li>Fail-to-deliver information</li>
                <li>Public regulatory information</li>
                <li>Other market-structure information</li>
              </ul>
              <p>
                Some market information is not personal information. However,
                it may become associated with other records or analytical
                datasets depending upon its source and use.
              </p>
              <h3>Community Information</h3>
              <p>
                When users participate in Traqstock community or communication
                features, we may process information such as:
              </p>
              <ul>
                <li>Usernames</li>
                <li>Profiles</li>
                <li>Posts</li>
                <li>Comments</li>
                <li>Messages Replies</li>
                <li>Uploaded content</li>
                <li>Community interactions</li>
                <li>Reports or complaints</li>
                <li>Moderation records</li>
                <li>Timestamps</li>
              </ul>
              <p>
                Information intentionally posted to public or shared areas of
                the platform may be visible to other users according to the
                functionality and privacy settings of the applicable Service.
              </p>
              <h3>Technical and Device Information</h3>
              <p>
                When users interact with Traqstock, we may automatically receive
                technical information such as:
              </p>
              <ul>
                <li>IP address</li>
                <li>Browser type</li>
                <li>Device type</li>
                <li>Operating system</li>
                <li>Device or session identifiers</li>
                <li>Login timestamps</li>
                <li>Security logs</li>
                <li>Application activity</li>
                <li>Referring pages</li>
                <li>Approximate location derived from an IP address</li>
                <li>Cookie and similar technology information</li>
              </ul>
              <p>
                This information may be used for authentication, security, fraud
                prevention, troubleshooting, analytics, performance monitoring,
                and operation of the Services.
              </p>
              <h3>Company and API Information</h3>
              <p>
                Companies and organizations integrating with Traqstock may
                provide information through APIs, software integrations, data
                feeds, files, or other authorized technical connections. The
                information processed depends upon the applicable integration,
                authorization, and contractual relationship.
              </p>
            </div>

            <div className="policysection">
              <h2>3. Traqstock Does Not Currently Operate A KYC Program</h2>
              <p>
                Traqstock does not currently operate a Know Your Customer
                ("KYC") program as part of the platform.
              </p>
              <p>
                Traqstock therefore does not currently require users to provide
                government-issued identification documents, Social Security
                numbers, identity photographs, or similar documentation to
                Traqstock for the purpose of completing a Traqstock-operated KYC
                process.
              </p>
              <p>
                If Traqstock introduces identity-verification or KYC
                functionality in the future, applicable privacy notices will be
                updated to describe the information collected, purposes of
                processing, service providers involved, and applicable privacy
                rights.
              </p>
            </div>

            <div className="policysection">
              <h2>4. How We Use Information</h2>
              <p>Traqstock may use information to:</p>
              <ul>
                <li>Provide and operate the Services</li>
                <li>Establish and manage accounts</li>
                <li>Authenticate users</li>
                <li>Protect accounts and platform integrity</li>
                <li>Provide market-data analytics</li>
                <li>Provide shareholder intelligence</li>
                <li>Aggregate and organize authorized datasets</li>
                <li>Analyze historical market information</li>
                <li>Generate analytical and behavioral indicators</li>
                <li>Compare information across authorized datasets</li>
                <li>Generate reports, dashboards, and visualizations</li>
                <li>Maintain historical analytical records</li>
                <li>Provide company and issuer analytics</li>
                <li>
                  Support investor-relations and shareholder-intelligence tools
                </li>
                <li>Operate community features</li>
                <li>Moderate platform activity</li>
                <li>Prevent spam, fraud, abuse, and impersonation</li>
                <li>Provide customer support</li>
                <li>Maintain system security</li>
                <li>Investigate technical or security incidents</li>
                <li>Operate APIs and integrations</li>
                <li>Maintain data provenance and integrity</li>
                <li>Create cryptographic verification records</li>
                <li>Improve and develop our Services</li>
                <li>Satisfy contractual obligations</li>
                <li>Protect Traqstock, our customers, users, and Services</li>
                <li>Comply with applicable legal obligations</li>
              </ul>
              <p>
                Where appropriate, Traqstock may also aggregate or de-identify
                information for analytics, research, security, product
                development, reporting, or other lawful purposes.
              </p>
            </div>

            <div className="policysection">
              <h2>5. Market Analytics And Behavioral Indicators</h2>
              <p>
                Traqstock technologies are designed to aggregate, organize,
                preserve, compare, and analyze information from multiple data
                sources.
              </p>
              <p>
                Our systems may identify statistical relationships, recurring
                patterns, anomalies, historical similarities, timing
                relationships, market-structure characteristics, behavioral
                indicators, confidence measurements, or other analytical
                observations. These analytical outputs are based upon available
                information and applicable methodologies.
              </p>
              <p>
                Traqstock's identification of a pattern, anomaly, behavioral
                indicator, or other analytical observation is not, by itself, a
                determination that unlawful activity, market manipulation,
                fraud, or other misconduct has occurred.
              </p>
              <p>
                Traqstock provides data and analytical indicators. Legal and
                regulatory determinations are the responsibility of the
                appropriate authorities.
              </p>
            </div>

            <div className="policysection">
              <h2>6. Shareholder Intelligence</h2>
              <p>
                Where authorized and legally permitted, Traqstock may process
                shareholder-related information to provide analytics to
                companies and other authorized customers.
              </p>
              <p>
                Depending upon the available data and applicable permissions,
                analytics may concern:
              </p>
              <ul>
                <li>Shareholder composition</li>
                <li>Ownership changes</li>
                <li>Ownership concentration</li>
                <li>Historical ownership trends</li>
                <li>Investor engagement</li>
                <li>Geographic or demographic information where lawfully available</li>
                <li>Communication activity</li>
                <li>Market activity</li>
                <li>Historical comparisons</li>
                <li>Statistical relationships between datasets</li>
              </ul>
              <p>
                Traqstock may provide aggregated, de-identified, or individually
                identifiable information depending upon the source of the
                information, the applicable authorization, contractual
                restrictions, and legal requirements.
              </p>
            </div>

            <div className="policysection">
              <h2>7. Private Blockchain And Data Integrity</h2>
              <p>
                Traqstock uses Hyperledger Fabric, a permissioned private
                blockchain framework, as part of its data-integrity
                architecture. Traqstock's blockchain infrastructure is not
                designed as an unrestricted public blockchain.
              </p>
              <p>
                Access to blockchain networks, nodes, channels, applications, or
                records may be restricted through permissions established within
                the Traqstock architecture.
              </p>
              <p>
                Depending upon the Service, blockchain technology may be used to
                establish or preserve:
              </p>
              <ul>
                <li>Cryptographic hashes</li>
                <li>Timestamps</li>
                <li>Data-integrity records</li>
                <li>Verification events</li>
                <li>Attestations</li>
                <li>Provenance records</li>
                <li>Analytical record references</li>
                <li>Historical references</li>
                <li>System events</li>
                <li>Audit-related records</li>
              </ul>
              <p>
                Traqstock may maintain underlying information separately from
                its corresponding blockchain integrity record. A blockchain entry
                may therefore establish that information existed, was received,
                was processed, or was analyzed at a particular point in time
                without requiring all underlying information to be recorded
                directly on the blockchain.
              </p>
              <h3>Blockchain Permanence</h3>
              <p>
                Blockchain technology is designed to maintain the integrity and
                continuity of historical records. As a result, certain records
                written to Traqstock's private blockchain may not be capable of
                conventional alteration or deletion.
              </p>
              <p>
                Deletion, correction, or anonymization of information contained
                within conventional systems therefore may not automatically
                remove a corresponding cryptographic hash, timestamp,
                verification record, or other blockchain integrity record.
              </p>
              <p>
                Traqstock will evaluate valid privacy requests according to
                applicable law and the technical characteristics of the relevant
                system.
              </p>
            </div>

            <div className="policysection">
              <h2>8. Cloud Infrastructure</h2>
              <p>
                Traqstock utilizes Amazon Web Services ("AWS") as part of its
                cloud hosting and infrastructure.
              </p>
              <p>
                Information processed through Traqstock may therefore be stored
                or processed using AWS infrastructure according to Traqstock's
                configurations, security controls, contractual arrangements, and
                the AWS services utilized by Traqstock.
              </p>
              <p>
                Traqstock may also utilize additional technology and service
                providers when reasonably necessary to operate and protect the
                Services.
              </p>
            </div>

            <div className="policysection">
              <h2>9. How Information May Be Disclosed</h2>
              <p>
                Open: the source text stops at the start of this section.
                Remaining text for Section 9 and any later sections (rights,
                retention, security, contact) still to be added.
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
